"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateID = exports.importMFEFactory = exports.getPageColorThemeClass = exports.getTouchpointThemeClass = void 0;
var Console_helper_1 = require("../../helpers/Console.helper");
var constants_1 = require("./constants");
function getTouchpointThemeClass(touchpoint) {
    if (touchpoint === void 0) { touchpoint = null; }
    var tp = constants_1.TOUCHPOINTS.UNIPOLSAI;
    if (touchpoint) {
        if (Object.values(constants_1.TOUCHPOINTS).includes(touchpoint)) {
            tp = touchpoint;
        }
        else {
            Console_helper_1.ConsoleHelper.error("Touchpoint ".concat(touchpoint, " not supported!"));
        }
    }
    return "touchpoint-theme-".concat(tp);
}
exports.getTouchpointThemeClass = getTouchpointThemeClass;
function getPageColorThemeClass(pageColor) {
    if (pageColor === void 0) { pageColor = null; }
    var pc = "default";
    if (pageColor && pageColor !== "mainColor") {
        if (Object.values(constants_1.PAGE_COLORS).includes(pageColor)) {
            pc = pageColor;
        }
        else {
            Console_helper_1.ConsoleHelper.error("Page color ".concat(pageColor, " not supported!"));
        }
    }
    return "page-color-theme-".concat(pc);
}
exports.getPageColorThemeClass = getPageColorThemeClass;
function importMFEFactory(props) {
    return !!props &&
        !!props.__host__ &&
        typeof props.__host__.importMFEBy === "function"
        ? function (__mfeName__) { return props.__host__.importMFEBy(__mfeName__); }
        : function (_) { return Promise.resolve(null); };
}
exports.importMFEFactory = importMFEFactory;
function generateID(containerID, str, index) {
    if (index === void 0) { index = null; }
    return "".concat(containerID, "-").concat(str, "-").concat(index !== null ? "".concat(index) : "wrapper");
}
exports.generateID = generateID;
